import React from "react";
import { inject } from "mobx-react";
import FeatherIcon from 'feather-icons-react';
import { hasTour } from '../../guides/tourRegistry';
import { startGuide } from '../../guides/guideManager';
import './HelpButton.scss';

// 페이지 가이드(온보딩 투어) 재생 버튼 — 페이지 헤더 어디에든 배치.
// 현재 라우트(또는 tourKey prop)에 등록된 투어가 없으면 아무것도 렌더하지 않는다.
@inject(({ common }) => ({ getCurNav: common.getCurNav }))
@inject(({ teamUser }) => ({ me: teamUser.me }))
class HelpButton extends React.Component {
  render() {
    const nav = this.props.getCurNav ? this.props.getCurNav() : {};
    const key = this.props.tourKey || (nav && nav.submenu && nav.submenu.name);
    if (!hasTour(key)) return null;

    const storeId = this.props.me && this.props.me.store && this.props.me.store._id;
    return (
      <button
        type="button"
        className={"orp-help-btn" + (this.props.className ? " " + this.props.className : "")}
        onClick={() => startGuide(key, { storeId }, { force: true })}
        title="페이지 가이드 보기"
        aria-label="페이지 가이드 보기"
      >
        <FeatherIcon icon="help-circle" size="16" />
      </button>
    );
  }
}

export default HelpButton;
